import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommercialPop} from '../models/commercialPop';

@Injectable()
export class PopService {

  constructor(private httpClient: HttpClient) {
  }

  getCommercialPops(): Observable<CommercialPop[]> {
    return this.httpClient.get<CommercialPop[]>(environment.baseUrlWs + '/api/commercial_pops');
  }

  getBwServiceTechnicalPops(commercialPop: string) {
    return this.httpClient.get<string[]>(environment.baseUrlWs + '/api/bw-service-technical-pop?pop=' + commercialPop);
  }

  getMdServiceTechnicalPops(commercialPop: string, service: string) {
    return this.httpClient.get<string[]>(environment.baseUrlWs + '/api/md-service-technical-pop?pop=' + commercialPop + '&service=' + service);
  }
}
